import React from 'react';
import ReactDOM from 'react-dom';
import {
  ThemeProvider,
  StylesProvider,
  createGenerateClassName,
} from '@material-ui/core/styles';
import { Provider } from 'react-redux';

import './index.css';

import theme from './theme';
import { store } from './redux/store';
import App from './components/app';
import reportWebVitals from './report-web-vitals';

// Preserve unique class names while keeping an app-specific prefix for MFE isolation.
const generateClassName = createGenerateClassName({
  productionPrefix: 'ipmcollab',
  seed: 'ipmcollab',
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <StylesProvider generateClassName={generateClassName}>
        <App />
      </StylesProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
